<template>

  <v-data-table ref="dataTable"
                :items="angebote"
                :items-per-page="10"
                :headers="headers"
                :search="search"
                :custom-filter="customFilter( superuser ?
                  ['Name', 'Produkt', 'Versicherungsumfang', 'Art', 'Angebotsnummer', 'vmnr', 'sbnr'] :
                  ['Name', 'Produkt', 'Versicherungsumfang', 'Art', 'Angebotsnummer'])"
                :sort-by="'Erstellt'"
                :sort-desc="true"
                :footer-props="footerProps"
                locale="de-DE"
                no-data-text="Keine Angebote vorhanden"
                no-results-text="Keine Angebote gefunden"
                must-sort
                class="data--table no--hover">

    <!--- data rows ----------------------------------------------------------------------------->
    <template v-slot:item="{item}">
      <tr>

      <td>{{ item.Erstellt | date }}</td>
      <td class="single--line">{{ item.Name }}</td>
      <td>{{ item.Produkt }}</td>
      <td>
        <versicherungsumfang :categories="item.Versicherungsumfang" />
      </td>
      <td>{{ item.Art }}</td>
      <td>{{ item.Angebotsnummer }}</td>
      <template v-if="superuser">
        <td>{{ item.vmnr }}</td>
        <td>{{ item.sbnr }}</td>
      </template>

      <!--- action menue ----------------------------------------------------------------------------->
      <td v-if="!superuser">
        <v-menu :nudge-bottom="24"
                bottom
                left
                content-class="table--actions">
          <template v-slot:activator="{on}">
            <v-icon v-on="on">more_vert</v-icon>
          </template>
          <v-list>
            <v-list-item v-if="!item.legacy"
                             @click="$emit('edit', item.Angebotsnummer)">
              <v-icon>edit</v-icon>
              <v-list-item-title>Bearbeiten</v-list-item-title>
            </v-list-item>

            <v-list-item @click="$emit('info', {type: 'ARB'})">
              <v-icon>info</v-icon>
              <v-list-item-title>ARB</v-list-item-title>
            </v-list-item>

            <v-list-item v-if="!item.legacy && !item.gewerbe"
                             @click="$emit('info', {type: 'Produktinfo', data: item.Produkt})">
              <v-icon>info</v-icon>
              <v-list-item-title>Produktinfo</v-list-item-title>
            </v-list-item>

            <v-list-item v-if="item.pdfpfad"
                         @click="$emit('details', item.Angebotsnummer)">
              <v-icon>insert_drive_file</v-icon>
              <v-list-item-title>PDF anzeigen</v-list-item-title>
            </v-list-item>

            <v-list-item @click="$emit('remove', item.Angebotsnummer)">
              <v-icon>delete</v-icon>
              <v-list-item-title>Löschen</v-list-item-title>
            </v-list-item>

          </v-list>
        </v-menu>
      </td>

      </tr>
    </template>

  </v-data-table>

</template>
<script>
import FiltersMixin from '@/components/kundenverwaltung/FiltersMixin';
import Versicherungsumfang from "@/components/kundenverwaltung/Versicherungsumfang";
import { FOOTER_PROPS } from '@/components/kundenverwaltung/tableConfig';

export default {
  name: "AngebotTable",
  components: {
    Versicherungsumfang
  },
  mixins: [FiltersMixin],
  props: {
    angebote: {
      type: Array,
      required: true
    },
    search: {
      type: String,
      default: ''
    },
    superuser: {
      type: Boolean,
      default: false
    }
  },
  data() {
    return {
      footerProps: FOOTER_PROPS,
      headers: this.superuser ?  [
        { text: 'Erstellt', value: 'Erstellt', sortable: true },
        { text: 'Name', value: 'Name', sortable: true },
        { text: 'Produkt', value: 'Produkt', sortable: true },
        { text: 'Versicherungsumfang', value: 'sortableVersicherungsumfang', sortable: true },
        { text: 'Art', value: 'Art', sortable: true },
        { text: 'Angebotsnummer', value: 'Angebotsnummer', sortable: true },
        { text: 'VMNR', value: 'vmnr', sortable: true },
        { text: 'SB-Nr', value: 'sbnr', sortable: true }
      ] : [
        { text: 'Erstellt', value: 'Erstellt', sortable: true },
        { text: 'Name', value: 'Name', sortable: true },
        { text: 'Produkt', value: 'Produkt', sortable: true },
        { text: 'Versicherungsumfang', value: 'sortableVersicherungsumfang', sortable: true },
        { text: 'Art', value: 'Art', sortable: true },
        { text: 'Angebotsnummer', value: 'Angebotsnummer', sortable: true },
        { text: ' ', value: 'actions', sortable: false }
      ]
    };
  }
};
</script>
